import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";


const groupName = window.location.hostname.slice(
    0,
    window.location.hostname.indexOf(".", 0)
);

const c = encodeURIComponent(Encrypt(groupName));

class AuthService {
  getSSOToken(auth) {
    return http.post(`/oauth/sso-token`, auth);
  }

  getExtensions() {
    return http.get(`masters/extensions?c=${c}`);
  }

  getScreenStatus() {
    return http.get(`masters/settings?c=${c}`);
  }

  getToken(ssoToken) {
    return http.post(`/oauth/token`, {
      token: ssoToken,
      userId: sessionStorage.getItem("user_id")
    });
  }

  getUserDetail(userId) {
    return http.get(`users/${userId}?c=${c}`);
  }
}

export default new AuthService();
